import React from 'react'
import profile from '../../images/login-bg.png'

const AuthBg = () => {
    return (
        <div className='auth-bg'>
            <img src={profile} alt='' />
        </div>
    )
}

export default AuthBg
